import { useState } from 'react';

export interface ModalProps<T = void> {
  isOpen: boolean;
  open: (props?: T) => void;
  close: () => void;
  props?: T;
}

export function useModal<T = void>(initial: boolean = false): ModalProps<T> {
  const [isOpen, setIsOpen] = useState(initial);
  const [props, setProps] = useState<T>();
  const open = (props?: T) => {
    setIsOpen(true);
    setProps(props);
  };
  const close = () => {
    setIsOpen(false);
    setProps(undefined);
  };

  return { isOpen, open, close, props };
}
